import PageHeader from '../components/PageHeader'
import { Container } from 'react-bootstrap'
import { useText } from '../context/TextContext'

export default function NotFoundPage() {
    const text = useText();
    return <Container className="pt-5">
        <PageHeader title={text.notFound} />
        <div className='center flex-column mt-5'>
            <h5>{text.notFoundDescription}</h5>
            <div style={{ maxHeight: '400px', maxWidth: '400px' }} className='overflow-hidden'>

                <img style={{ maxHeight: '100%', maxWidth: '100%' }} src='/404.png' alt='404' className='img-fluid mt-5' />
            </div>

        </div>
    </Container>
}

